






























































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import moment from 'moment';

import { ErrorManager } from '@/models/error';
import { IWorkflowFormSubmission, IWorkflowTransitionLog } from '@/models';

import ALDialog from '../core/Dialog/ALDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import WorkflowStateStatusDisplay from '@/components/workflows/WorkflowStateStatusDisplay.vue';

export default Vue.extend({
  components: { ErrorAlert, WorkflowStateStatusDisplay, ALDialog },

  data: () => ({
    dialog: false,
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',

    workflowFormSubmission: {} as IWorkflowFormSubmission,

    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: false,
        value: 'created'
      },
      {
        text: 'Changed By',
        align: 'center',
        sortable: false,
        value: 'user'
      },

      {
        text: 'Notes',
        align: 'start',
        sortable: false,
        value: 'notes'
      },
      {
        text: 'Previous State',
        align: 'center',
        sortable: false,
        value: 'transition.source_state'
      },
      {
        text: 'Current State',
        align: 'center',
        sortable: false,
        value: 'transition.target_state'
      }
    ]
  }),

  computed: {
    workflowFormSubmissionActivities: get<IWorkflowTransitionLog[]>(
      'workflowForm/getWorkflowFormSubmissionActivities'
    )
  },

  methods: {
    moment,

    ...mapActions({
      fetchWorkflowFormSubmissionActivities:
        'workflowForm/fetchWorkflowFormSubmissionActivities'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    open(workflowFormSubmission: IWorkflowFormSubmission) {
      this.clearAllErrors();

      this.workflowFormSubmission = workflowFormSubmission;

      this.dialog = true;
      this.loading = true;

      this.fetchWorkflowFormSubmissionActivities(workflowFormSubmission.id)
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.dialog = false;
    }
  }
});
